import {EmailSubscriptionType} from '../../../grpc_client/grips/protos/email_subscriptions/v1/email_subscription';
import {DropType} from '../../../grpc_client/grips/protos/shared/drop';

export const DROP_PATH_TO_TYPE_MAP: {[key: string]: DropType} = {
  ay_label_drop: DropType.DROP_TYPE_AY_LABEL,
  shoes_drop: DropType.DROP_TYPE_SHOE,
  premium_drop: DropType.DROP_TYPE_AY_PREMIUM,
  invalid: DropType.DROP_TYPE_INVALID,
};

export const DROP_TYPE_SUBSCRIPTION_MAP: {
  [key in DropType]: EmailSubscriptionType;
} = {
  [DropType.UNRECOGNIZED]: EmailSubscriptionType.UNRECOGNIZED,
  [DropType.DROP_TYPE_INVALID]:
    EmailSubscriptionType.EMAIL_SUBSCRIPTION_TYPE_INVALID,
  [DropType.DROP_TYPE_AY_PREMIUM]:
    EmailSubscriptionType.EMAIL_SUBSCRIPTION_TYPE_INVALID, // AYFEP-492 - no all subscription
  [DropType.DROP_TYPE_AY_LABEL]:
    EmailSubscriptionType.EMAIL_SUBSCRIPTION_HOT_DROPS_AY_LABEL,
  [DropType.DROP_TYPE_SHOE]:
    EmailSubscriptionType.EMAIL_SUBSCRIPTION_HOT_DROPS_SNEAKER,
  [DropType.DROP_TYPE_LIVE_SHOW]:
    EmailSubscriptionType.EMAIL_SUBSCRIPTION_TYPE_INVALID,
};

export const DROPS_SUBSCRIBED_STORAGE_KEY = 'dropsSubscription';
export const DROP_TYPE_TO_PATH_MAP = {
  [DropType.DROP_TYPE_AY_LABEL]: 'ay_label_drop',
  [DropType.DROP_TYPE_SHOE]: 'shoes_drop',
  [DropType.DROP_TYPE_LIVE_SHOW]: 'live_show',
  [DropType.DROP_TYPE_AY_PREMIUM]: 'premium_drop',
  [DropType.DROP_TYPE_INVALID]: 'invalid',
};
